import routes from './invoice.routes';

export const invoiceModule = {
    routes
};